import React, { useEffect, useRef, useState } from "react";
import { useLogs } from "../context/LogContext";
import "./Profile.css";
import { useEncryptDecrypt } from "../utils/EncryptedDecrypted";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [device, setDevice] = useState(null);

  const [decryptedUser, setDecryptedUser] = useState(null); // 👈 store decrypted data
  const [decryptedDevice, setDecryptedDevice] = useState(null); // 👈 store decrypted data
  const [formattedDate, setFormattedDate] = useState(null); //

  const { addLog } = useLogs();
  const { decrypt } = useEncryptDecrypt();
  const loggedRef = useRef({ loaded: false, userDecrypted: false, deviceDecrypted: false });

  useEffect(() => {
    const saved = localStorage.getItem("userData");

    if (saved) {
      const parsed = JSON.parse(saved);
      setUser(parsed.user);
      setDevice(parsed.device);

      if (!loggedRef.current.loaded) {
        loggedRef.current.loaded = true;
        addLog("👤 Loaded profile details");
      }
    }
  }, [addLog]);

  // 🔥 Decrypt only once when 'user' is set
  useEffect(() => {
    if (user) {
      console.log("user", user);
      const decrypted = {
        // email: decrypt(user.email),
        firstName: decrypt(user.firstName),
        lastName: decrypt(user.lastName),
        phone: decrypt(user.phoneNumber),
      };
      const formatted = new Date(user.createdAt).toLocaleString();
      setFormattedDate(formatted);
      setDecryptedUser(decrypted);
      if (!loggedRef.current.userDecrypted) {
        loggedRef.current.userDecrypted = true;
        addLog("🔐 Decrypted user data");
      }
    }
  }, [user, decrypt, addLog]);
  useEffect(() => {
    if (device) {
      console.log("device", device);
      const decrypted = {
        deviceName: device.deviceName,
        deviceKey: decrypt(device.deviceKey),
      };
      setDecryptedDevice(decrypted);
      if (!loggedRef.current.deviceDecrypted) {
        loggedRef.current.deviceDecrypted = true;
        addLog("🔐 Decrypted device data");
      }
    }
  }, [device, decrypt, addLog]);

  if (!user || !decryptedUser)
    return <div className="profile-container">Loading Profile...</div>;

  return (
    <div className="profile-container">
      <div className="profile-card">
        <h2 className="profile-title">User Profile</h2>

        {/* <div className="profile-img-wrap">
          <img src={user.profilePic} alt="Profile" className="profile-img" />
        </div> */}

        <div className="section">
          <h3>Personal Info</h3>
          {/* <div className="item">
            <span>Email:</span> {decryptedUser.email}
          </div> */}
          <div className="item">
            <span>First Name:</span> {decryptedUser.firstName}
          </div>
          <div className="item">
            <span>Last Name:</span> {decryptedUser.lastName}
          </div>
          <div className="item">
            <span>Phone:</span> {decryptedUser.phone}
          </div>
        </div>

        <div className="section">
          <h3>Device Info</h3>
          <div className="item">
            <span>Device Name:</span> {decryptedDevice?.deviceName}
          </div>
          <div className="item">
            <span>Device Key:</span> {decryptedDevice?.deviceKey}
          </div>
        </div>

        <div className="section">
          <h3>Account Info</h3>
          {/* <div className="item">
            <span>Email Verified:</span> {user.emailVerified ? "Yes" : "No"}
          </div> */}
          <div className="item">
            <span>Created:</span> {formattedDate}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Profile;
